import React, { 
  //useState 
} from 'react';
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import {
  Image,
} from 'semantic-ui-react';

export default function UtilImage({imageType, altText, image, semanticProps, imageSize}) {
  //console.debug('UtilImage', {altText, image});
  /* const imageUrlString = image.urls && image.urls.length !== 0 ? image.urls[0] : null;
  const imageFileExtension = imageUrlString && imageUrlString.split('.').pop();
  if (imageFileExtension === 'gif') {
    //console.debug('UtilImage - found gif image', {imageUrlString, imageFileExtension});
  } */
  return (
    imageType === 'card' ?
      <CardImage altText={altText} image={image} imageSize={imageSize} />
    : imageType === 'content-slider' ?
      <ContentSliderSlideImage altText={altText} image={image} />
    :
      <ContentBasicImage altText={altText} image={image} semanticProps={semanticProps} />
  )
}
//content-basic-image image elements
const ContentBasicImage = ({altText, image, semanticProps}) => {
  const { centered, rounded, circular, verticalAlign, size, } = semanticProps
  const gatsbyImageSemanticClasses = {
    rounded: rounded ? ' rounded' : '',
    circular: circular ? ' circular' : '',
    centered: centered ? ' centered' : '',
    verticalAlign: verticalAlign ? ' '+verticalAlign : '',
  }
  return (
    image.gatsbyImageData ?
      <GatsbyImage 
        className={'ui image'+(size !== null ? (' '+size) : '')+gatsbyImageSemanticClasses.rounded+gatsbyImageSemanticClasses.circular+gatsbyImageSemanticClasses.centered+gatsbyImageSemanticClasses.verticalAlign} 
        image={getImage(image.gatsbyImageData)} 
        alt={altText}  
      />
    : image.gatsbyLocalFile && image.gatsbyLocalFile.publicURL ?
      <Image alt={altText}
        src={image.gatsbyLocalFile.publicURL}
        size={size !== 'fluid' ? size : null}
        fluid={size === 'fluid' ? true : false}
        rounded={rounded}
        circular={circular}
        centered={centered}
        verticalAlign={verticalAlign !== '' ? verticalAlign : null}
      />
    : image.imageAbsoluteUrls && image.imageAbsoluteUrls.length !== 0 ?
      <Image alt={altText}
        src={image.imageAbsoluteUrls[0]} 
        size={size !== 'fluid' ? size : null} 
        fluid={size === 'fluid' ? true : false} 
        rounded={rounded}
        circular={circular}
        centered={centered}
        verticalAlign={verticalAlign !== '' ? verticalAlign : null}
      />
    :
      null
  )
}

//semantic-ui card image elements
const CardImage = ({altText, image, imageSize}) => {
  //console.debug('CardImage', {altText, image, imageSize});
  const setImageSize = imageSize ? imageSize : 'fluid';
  
  return (
    image.gatsbyImageData ?
      <div className={'ui image '+setImageSize}>
        <GatsbyImage objectFit={'cover'} objectPosition={'50% 50%'} image={getImage(image.gatsbyImageData)} alt={altText} />
      </div>
    : image.gatsbyLocalFile && image.gatsbyLocalFile.publicURL ?
      <Image wrapped ui={false} fluid size={imageSize ? imageSize : null} src={image.gatsbyLocalFile.publicURL} alt={altText} /> 
    : image.imageAbsoluteUrls && image.imageAbsoluteUrls.length !== 0 ?
      <Image wrapped ui={false} fluid size={imageSize ? imageSize : null} src={image.imageAbsoluteUrls[0]} alt={altText} />
    :
      null
  )
}

//content-slider slide image elements
const ContentSliderSlideImage = ({altText, image, semanticProps}) => {
  const { size, } = semanticProps
  return (
    image.gatsbyImageData ?
      <GatsbyImage className={'ui image '+(size !== null ? size : '')} image={getImage(image.gatsbyImageData)} alt={altText} />
    : image.gatsbyLocalFile && image.gatsbyLocalFile.publicURL ?
      <Image fluid src={image.gatsbyLocalFile.publicURL} alt={altText} /> 
    : image.imageAbsoluteUrls && image.imageAbsoluteUrls.length !== 0 ?
      <Image fluid src={image.imageAbsoluteUrls[0]} alt={altText} />
    :
      null
  )
}